import React, {useState} from 'react';
import {IoMdCheckmark, IoMdHelpCircleOutline} from 'react-icons/io';
import { RenderIf } from '../RenderIf';

import {
  Container,
  ContentContainer,
  HelpButton,
  HelpText,
  SelectionContainer,
  Text
} from './styles';

export function Checkbox({
  isSelected = true,
  text = 'Texto',
  helpText = '',
  onSelectionPress = () => {}
}) {
  const [isHelpHovered, setIsHelpHovered] = useState(false);
  
  return (
    <Container>
      <ContentContainer onClick={onSelectionPress}>
        <SelectionContainer isSelected={isSelected}>
          <RenderIf isTrue={isSelected}>
            <IoMdCheckmark color="#FFF" size="1.5em"/>
          </RenderIf>
        </SelectionContainer>
        <Text>{text}</Text>
      </ContentContainer>
      <RenderIf isTrue={!!helpText}>
        <HelpButton
          onMouseEnter={() => setIsHelpHovered(true)}
          onMouseLeave={() => setIsHelpHovered(false)}
        >
          <IoMdHelpCircleOutline size="1.2em"/>
        </HelpButton>
        <RenderIf isTrue={isHelpHovered}>
          <HelpText>{helpText}</HelpText>
        </RenderIf>
      </RenderIf>
    </Container>
  );
}